import axios, { AxiosResponse } from 'axios'
import { ServiceUnavailable } from 'common/errors/ServiceUnavailable'
import { BaseError } from 'src/editor/api/errors/base-error'

type HttpMethodType = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

interface RequestOptionsInterface<T> {
  data?: T
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  params?: Record<string, any>
}

export const request = axios.create({
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

export const websiteRequest = async <T, U = unknown>(
  url: string,
  method: HttpMethodType,
  options: RequestOptionsInterface<U> = {},
): Promise<T> => {
  try {
    const { data, params } = options
    const response: AxiosResponse<T> = await request({
      method,
      url: `/api/dashboard/website/${url}`,
      data,
      params,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 503) {
      throw new ServiceUnavailable(error.response)
    }
    if (axios.isAxiosError(error) && error.response?.data) {
      throw new BaseError(error.response.data)
    }
    throw error
  }
}
